module.exports = __webpack_public_path__ + "static/Bugsnag-1c90c9f5a951c8b7157422fc14c1d282.png";